/**
 * Countdown Timer - JavaScript functionality
 * Handles timer logic, presets, audio alerts, and fullscreen mode
 */
(function () {
    'use strict';

    let totalSeconds = 0;
    let remainingSeconds = 0;
    let timerInterval = null;
    let isRunning = false;
    let audioContext = null;

    /**
     * Initialize the audio context for alarm sounds
     */
    function initAudio() {
        if (!audioContext) {
            audioContext = new (window.AudioContext || window.webkitAudioContext)();
        }
    }

    /**
     * Play the alarm sound when timer completes
     */
    function playAlarm() {
        if (!document.getElementById('soundEnabled').checked) return;

        initAudio();

        // Play a series of beeps
        const beepCount = 5;
        for (let i = 0; i < beepCount; i++) {
            setTimeout(function () {
                const oscillator = audioContext.createOscillator();
                const gainNode = audioContext.createGain();

                oscillator.connect(gainNode);
                gainNode.connect(audioContext.destination);

                oscillator.frequency.value = 800;
                oscillator.type = 'sine';

                gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
                gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.3);

                oscillator.start(audioContext.currentTime);
                oscillator.stop(audioContext.currentTime + 0.3);
            }, i * 400);
        }
    }

    /**
     * Test the alarm sound
     */
    function testSound() {
        initAudio();
        const oscillator = audioContext.createOscillator();
        const gainNode = audioContext.createGain();

        oscillator.connect(gainNode);
        gainNode.connect(audioContext.destination);

        oscillator.frequency.value = 800;
        oscillator.type = 'sine';

        gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
        gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.3);

        oscillator.start(audioContext.currentTime);
        oscillator.stop(audioContext.currentTime + 0.3);
    }

    /**
     * Set a preset timer duration
     * @param {number} minutes - Number of minutes for the timer
     */
    function setPreset(minutes) {
        totalSeconds = minutes * 60;
        remainingSeconds = totalSeconds;
        updateDisplay();
    }

    /**
     * Set a preset timer with a label
     * @param {number} minutes - Number of minutes for the timer
     * @param {string} label - Label for the timer
     */
    function setPresetWithLabel(minutes, label) {
        setPreset(minutes);
        document.getElementById('customLabel').value = label;
        document.getElementById('timerLabel').textContent = label;
    }

    /**
     * Set a custom time from the input fields
     */
    function setCustomTime() {
        const hours = parseInt(document.getElementById('hoursInput').value) || 0;
        const minutes = parseInt(document.getElementById('minutesInput').value) || 0;
        const seconds = parseInt(document.getElementById('secondsInput').value) || 0;

        totalSeconds = (hours * 3600) + (minutes * 60) + seconds;
        remainingSeconds = totalSeconds;
        updateDisplay();

        const label = document.getElementById('customLabel').value;
        if (label) {
            document.getElementById('timerLabel').textContent = label;
        }
    }

    /**
     * Update the timer display
     */
    function updateDisplay() {
        const hours = Math.floor(remainingSeconds / 3600);
        const minutes = Math.floor((remainingSeconds % 3600) / 60);
        const seconds = remainingSeconds % 60;

        document.getElementById('timerDisplay').textContent =
            hours.toString().padStart(2, '0') + ':' +
            minutes.toString().padStart(2, '0') + ':' +
            seconds.toString().padStart(2, '0');

        // Update page title
        if (isRunning) {
            document.title = document.getElementById('timerDisplay').textContent + ' - Countdown Timer';
        }

        // Visual feedback when low
        const display = document.getElementById('timerDisplay');
        if (remainingSeconds <= 10 && remainingSeconds > 0 && isRunning) {
            display.classList.add('timer-warning');
        } else {
            display.classList.remove('timer-warning');
        }
    }

    /**
     * Start the timer
     */
    function startTimer() {
        if (remainingSeconds <= 0) {
            return;
        }

        initAudio();
        isRunning = true;
        document.getElementById('startBtn').disabled = true;
        document.getElementById('pauseBtn').disabled = false;

        const label = document.getElementById('customLabel').value;
        if (label && document.getElementById('timerLabel').textContent === 'Set your timer') {
            document.getElementById('timerLabel').textContent = label;
        }

        timerInterval = setInterval(function () {
            remainingSeconds--;
            updateDisplay();

            if (remainingSeconds <= 0) {
                clearInterval(timerInterval);
                isRunning = false;
                document.getElementById('startBtn').disabled = false;
                document.getElementById('pauseBtn').disabled = true;
                document.getElementById('timerDisplay').classList.add('timer-complete');
                document.getElementById('timerLabel').textContent = "Time's up!";
                document.title = "Time's up! - Countdown Timer";
                playAlarm();
            }
        }, 1000);
    }

    /**
     * Pause the timer
     */
    function pauseTimer() {
        clearInterval(timerInterval);
        isRunning = false;
        document.getElementById('startBtn').disabled = false;
        document.getElementById('pauseBtn').disabled = true;
        document.title = 'Countdown Timer';
    }

    /**
     * Reset the timer to the initial state
     */
    function resetTimer() {
        clearInterval(timerInterval);
        isRunning = false;
        remainingSeconds = totalSeconds;
        updateDisplay();
        document.getElementById('startBtn').disabled = false;
        document.getElementById('pauseBtn').disabled = true;
        document.getElementById('timerDisplay').classList.remove('timer-complete', 'timer-warning');
        document.getElementById('timerLabel').textContent = document.getElementById('customLabel').value || 'Set your timer';
        document.title = 'Countdown Timer';
    }

    /**
     * Toggle fullscreen mode for the timer display
     */
    function toggleFullscreen() {
        const container = document.querySelector('.timer-container');
        if (!document.fullscreenElement) {
            container.requestFullscreen();
        } else {
            document.exitFullscreen();
        }
    }

    /**
     * Initialize keyboard shortcuts
     */
    function initKeyboardShortcuts() {
        document.addEventListener('keydown', function (e) {
            if (e.target.tagName === 'INPUT') return;

            if (e.code === 'Space') {
                e.preventDefault();
                if (isRunning) {
                    pauseTimer();
                } else {
                    startTimer();
                }
            } else if (e.code === 'KeyR') {
                resetTimer();
            } else if (e.code === 'KeyF') {
                toggleFullscreen();
            }
        });
    }

    // Expose public API
    window.CountdownTimer = {
        setPreset: setPreset,
        setPresetWithLabel: setPresetWithLabel,
        setCustomTime: setCustomTime,
        startTimer: startTimer,
        pauseTimer: pauseTimer,
        resetTimer: resetTimer,
        toggleFullscreen: toggleFullscreen,
        testSound: testSound
    };

    /**
     * Wire up event listeners for all interactive elements
     */
    function initEventListeners() {
        // Preset buttons (delegated)
        document.addEventListener('click', function (e) {
            var presetBtn = e.target.closest('.preset-btn[data-preset]');
            if (presetBtn) {
                setPreset(parseInt(presetBtn.dataset.preset));
            }
            var useCaseCard = e.target.closest('.use-case-card[data-preset]');
            if (useCaseCard) {
                setPresetWithLabel(parseInt(useCaseCard.dataset.preset), useCaseCard.dataset.label || '');
            }
        });

        // Action buttons
        var setCustomTimeBtn = document.getElementById('setCustomTimeBtn');
        if (setCustomTimeBtn) setCustomTimeBtn.addEventListener('click', setCustomTime);

        var startBtn = document.getElementById('startBtn');
        if (startBtn) startBtn.addEventListener('click', startTimer);

        var pauseBtn = document.getElementById('pauseBtn');
        if (pauseBtn) pauseBtn.addEventListener('click', pauseTimer);

        var resetBtn = document.getElementById('resetBtn');
        if (resetBtn) resetBtn.addEventListener('click', resetTimer);

        var fullscreenBtn = document.getElementById('fullscreenBtn');
        if (fullscreenBtn) fullscreenBtn.addEventListener('click', toggleFullscreen);

        var testSoundBtn = document.getElementById('testSoundBtn');
        if (testSoundBtn) testSoundBtn.addEventListener('click', testSound);
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            initKeyboardShortcuts();
            initEventListeners();
        });
    } else {
        initKeyboardShortcuts();
        initEventListeners();
    }
})();
